/* DigiSnap motion system — scroll reveals, header scroll state, and a small
   amount of parallax. Everything here is additive: if this script never
   runs, or the browser lacks IntersectionObserver, every [data-reveal]
   element is plain, fully visible content (see digisnap-motion.css) — the
   site never depends on this file to be usable or readable. */
(function () {
  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealEverythingNow() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // Reduced motion, or no IntersectionObserver support: nothing is ever
  // going to trigger a scroll reveal, so just show the content — no reason
  // to wait.
  if (prefersReduced || !('IntersectionObserver' in window)) {
    revealEverythingNow();
    return;
  }

  try {
    document.documentElement.classList.add('ds-motion-ready');

    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
    );

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      revealObserver.observe(el);
    });

    // Safety net for stragglers only — NOT a blanket "reveal everything"
    // timer. A single fixed-delay reveal-everything (the previous approach)
    // is actually harmful here: on a long homepage, it fires once at a
    // fixed time after load and force-reveals every section at once,
    // including ones still far below the fold. By the time the visitor
    // scrolls down to them minutes later, they're already sitting at their
    // final "revealed" state with nothing left to animate — which is
    // exactly why only the first couple of sections ever appeared to
    // animate. Instead, poll periodically and only reveal elements that
    // are ACTUALLY in (or near) the viewport right now but somehow never
    // got marked by the observer — everything still below the fold is left
    // alone so it gets its real scroll-triggered reveal when it arrives.
    var strayCheck = window.setInterval(function () {
      var pending = document.querySelectorAll('[data-reveal]:not(.is-visible)');
      if (!pending.length) {
        window.clearInterval(strayCheck);
        return;
      }
      pending.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
          el.classList.add('is-visible');
          revealObserver.unobserve(el);
        }
      });
    }, 1200);
  } catch (error) {
    // If anything above threw, don't leave content hidden behind a class
    // the (broken) observer will never satisfy — reveal immediately.
    revealEverythingNow();
  }

  try {
    // Header: subtle transparent-over-hero -> solid-over-content transition.
    var nav = document.querySelector('[data-ds-nav]');
    if (nav) {
      var scrolledState = false;
      var ticking = false;

      var setState = function () {
        var shouldBeScrolled = window.scrollY > 24;
        if (shouldBeScrolled !== scrolledState) {
          scrolledState = shouldBeScrolled;
          nav.classList.toggle('is-scrolled', scrolledState);
        }
        ticking = false;
      };

      setState();
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            window.requestAnimationFrame(setState);
            ticking = true;
          }
        },
        { passive: true }
      );
    }
  } catch (error) {
    // Non-fatal: worst case the header just stays in its resting (not-yet-
    // scrolled) visual state — never affects whether the header is usable.
  }

  try {
    // A small, deliberate amount of parallax — desktop only, and only for
    // elements explicitly opted in with data-parallax="<0-1 speed>".
    if (!prefersReduced && window.matchMedia('(min-width: 821px)').matches) {
      var parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));

      if (parallaxEls.length) {
        var parallaxTicking = false;

        var updateParallax = function () {
          parallaxEls.forEach(function (el) {
            var speed = parseFloat(el.getAttribute('data-parallax')) || 0.05;
            var rect = el.getBoundingClientRect();
            var travel = (rect.top - window.innerHeight / 2) * speed;
            el.style.transform = 'translate3d(0, ' + travel.toFixed(1) + 'px, 0)';
          });
          parallaxTicking = false;
        };

        updateParallax();
        window.addEventListener(
          'scroll',
          function () {
            if (!parallaxTicking) {
              window.requestAnimationFrame(updateParallax);
              parallaxTicking = true;
            }
          },
          { passive: true }
        );
        window.addEventListener('resize', updateParallax);
      }
    }
  } catch (error) {
    // Non-fatal: parallax is a bonus effect, never required for the page
    // (and any elements it targets are laid out normally without it).
  }
})();
